import { ICONS } from '@frontend/icons';

export interface DefaultContainerProps {
    title?: React.ReactNode;
    content: React.ReactNode;
    styles?: {
        container?: string;
    };
    update?: {
        onUpdate: () => void;
        hide?: boolean;
    };
    delete?: {
        onDelete: () => void;
        hide?: boolean;
    };
}

export const DefaultContainer = (props: DefaultContainerProps) => {
    const showUpdate = Boolean(props.update && !props.update.hide);
    const showDelete = Boolean(props.delete && !props.delete.hide);
    const showHeader = props.title != null || showUpdate || showDelete;

    return (
        <div
            className={`${props.styles?.container ?? 'w-full'} bg-background-surface border-border-default inline-flex flex-col items-start justify-start gap-6 self-stretch rounded-xl border p-4`}>
            {showHeader ? (
                <div className='inline-flex items-center justify-between self-stretch'>
                    <div className='text-foreground-default justify-start text-xl font-semibold'>{props.title}</div>
                    <div className='flex gap-2'>
                        {showUpdate ? (
                            <ICONS.BUTTON.UPDATE
                                onClick={() => props.update!.onUpdate()}
                                className='text-foreground-default hover:text-brand-primary size-6 cursor-pointer'
                            />
                        ) : null}
                        {showDelete ? (
                            <ICONS.BUTTON.DELETE
                                onClick={() => props.delete!.onDelete()}
                                className='text-foreground-default hover:text-status-danger size-6 cursor-pointer'
                            />
                        ) : null}
                    </div>
                </div>
            ) : null}
            {props.content}
        </div>
    );
};
